/*
 * @Description: 固定常用数据
 * @Author: 编辑人
 * @Date: 2021-08-31 18:54:19
 */
const state = {
  productTipColumns: [
    { pram: "picture", label: "组件图片", img: true },
    { pram: "code", label: "组件编号" },
    { pram: "name", label: "组件名称" },
    // { pram: "specs/making", label: "规格型号", splice: true },
    { pram: "sort", label: "产品分类" },
  ],
}
export default {
  namespaced: true,
  state
}
